export default function repositorio() {
    return (
        <>
             <a href="https://github.com/Zanardi25/Execs-React" target="_blank">Link do repositorio do github</a>
        </>
    ) 
}
